import dayjs from 'dayjs';
import { LanguageType } from 'app/shared/model/enumerations/language-type.model';

export interface IContact {
  id?: number;
  initials?: string;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  fax?: string | null;
  language?: keyof typeof LanguageType;
  birthday?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<IContact> = {};
